import { debounce } from "../utils/Performance";
import dynamicElements from "../utils/dynamicElements";

class EventBoookingHeader {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.stickyClass = "is-sticky";
        this.offset = 0;
        this.observer = null;
        this.height = 0;
        this.placeholder = null;

        this.checkInit();

        window.addEventListener(
            "resize",
            debounce(() => {
                this.checkInit();
            }, 250),
        );
    }

    checkInit() {
        if (window.matchMedia("(min-width: 992)").matches) {
            if (!this.observer) {
                this.init();
            }
        } else {
            if (this.observer) {
                this.destroy();
            }
        }
    }

    init() {
        // Calculate initial height
        this.height = this.el.offsetHeight;

        // Create placeholder with same height
        this.placeholder = document.createElement("div");
        this.placeholder.style.height = `${this.height}px`;
        this.placeholder.style.display = "none";
        this.el.parentNode.insertBefore(this.placeholder, this.el);

        const sentinel = document.createElement("div");
        sentinel.style.position = "absolute";
        sentinel.style.top = `${this.offset}px`;
        this.el.parentNode.insertBefore(sentinel, this.el);

        this.observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    this.el.classList.add(this.stickyClass);
                    this.placeholder.style.display = "block";
                } else {
                    this.el.classList.remove(this.stickyClass);
                    this.placeholder.style.display = "none";
                }
            },
            { rootMargin: `-${this.offset}px 0px 0px 0px`, threshold: 0 },
        );

        this.observer.observe(sentinel);
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }

        if (this.placeholder) {
            this.placeholder.remove();
        }

        this.el.classList.remove(this.stickyClass);
    }
}

dynamicElements.define(
    ".page-header--event .page-header__content-inner-wrap",
    (el) => new EventBoookingHeader(el),
    {
        watch: false,
    },
);
